import React, { useEffect, useState } from 'react';
export function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <header className={`fixed top-0 left-0 right-0 z-[200] transition-all duration-500 ${scrolled ? 'bg-verde-oscuro/95 backdrop-blur-md border-b border-dorado/20 py-3' : 'bg-transparent py-5'}`} data-id="element-14">
      <div className="container-custom flex items-center justify-between" data-id="element-15">
        <a href="#hero" data-id="element-16">
          <img src="https://i.postimg.cc/VkcMmqSb/logo-284.webp" alt="Protocolo Digestivo 72 Horas" className="h-10 w-auto object-contain" data-id="element-17" />
        </a>
      </div>
    </header>;
}